import React, { useEffect } from 'react';
import ApprovalFormContainer from './ApprovalFormContainer';
import { useDispatch, useSelector } from 'react-redux';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PurchaseBillHistoryForApproval from '../projectmng/bill_mng/PurchaseBillHistoryForApproval';
import SalesBillHistoryForApproval from '../projectmng/bill_mng/SalesBillHistoryForApproval';
import OrderBookInfoContainer from '../projectmng/obtainorder/OrderBookInfoContainer';
import { viewProject } from '../../modules/projectModule/project';
import { viewOrder } from '../../modules/projectModule/order';
import ApprovalTaxSummary from '../../components/approval/ApprovalTaxSummary';
import { viewApprovalTaxbillByTrjId } from '../../modules/approvalModule/issue-taxbills';

const ApprovalTaxViewContainer = ({ id }) => {
  const dispatch = useDispatch();
  const { user, approval, taxbill, prjUuid, roUuid, project, receiveOrderInf } =
    useSelector(({ auth, userModule, approvalModule, projectModule }) => ({
      user: auth.user,
      approval: userModule.approval.approval,
      prjUuid: userModule.approval.prjUuid,
      roUuid: userModule.approval.roUuid,
      project: projectModule.project.project,
      receiveOrderInf: projectModule.order.receiveOrderInf,
      taxbill: approvalModule.issueTaxbills.taxbill,
    }));

  useEffect(() => {
    if (prjUuid) {
      dispatch(viewProject(prjUuid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prjUuid]);

  useEffect(() => {
    if (roUuid) {
      dispatch(viewOrder(roUuid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roUuid]);

  useEffect(() => {
    if (id) {
      dispatch(viewApprovalTaxbillByTrjId(id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <ApprovalFormContainer docuCd={id} user={user} type="tax" />
      <DetailTemplate title="개요">
        <ApprovalTaxSummary info={approval} taxbill={taxbill} />
      </DetailTemplate>
      {approval?.docuTxt && approval?.docuTxt !== '' && (
        <DetailTemplate title="결재 참고사항">
          <Box>
            <Typography variant="body2" component="div">
              {approval?.docuTxt}
            </Typography>
          </Box>
        </DetailTemplate>
      )}

      <DetailTemplate title="상세내역">
        <OrderBookInfoContainer
          orderInfo={receiveOrderInf}
          project={project}
          isLink
        />
      </DetailTemplate>
      <DetailTemplate title="매입 계산서 내역">
        <PurchaseBillHistoryForApproval docuCd={id} />
      </DetailTemplate>
      <DetailTemplate title="매출 계산서 내역">
        <SalesBillHistoryForApproval docuCd={id} />
      </DetailTemplate>
    </>
  );
};

export default ApprovalTaxViewContainer;
